/*
 * @Author: lvjun
Date：2021-27
 * @Description: 定义项目常量
 */

export const noType = {
  // 单号类型
  trackingNo: 1,
  orderNo: 2,
};

// 后端语种与element国际化的对应map
export const LANG_ELEMENT_MAP = {
  CN: "zh-cn", // 中文
  EN: "en", // 英语
  TH: "th", // 泰语
  KH: "kh", // 柬埔寨(暂无)
  MY: "my", // 马来语(暂无)
  ID: "id", // 印尼语
  VN: "vi", // 越南语
};

// 请求超时时间 15s
export const TIMEOUT_TIMES = 15000;

// 接口等待时间 1000ms INTW_TIMES-> interface waiting times
export const INTW_TIMES = 1000;

// 接口等待开关状态
export const INTW_SWITCH = true;

//接口前缀
export const APICUS = "bpo";

// 请求成功
export const RESPONSE_SUCCESS = 1;

export const INTERSTATUS = [];

//////////////////// 不需要的后续删除

// 网点经营标识-小写
export const SITE_TAG_LOWER = "site";

// 网点经营标识-首字母大写
export const SITE_TAG_UP = "Site";

// 网点类型-总部 code:16
export const NT_HEADQUARTERS = 22;

// 网点类型-代理区 code:17
export const NT_AGENT_AREA = 334;

// 网点类型-中心 code:18
export const NT_CENTER = 335;

// 网点类型-一级网点 code:19
export const NT_FIRST_LEVEL = 336;

// 网点类型-二级网点 code:20
export const NT_SECOND_LEVEL = 337;
